"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterProvider = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var root_1 = require("react-hot-loader/root");
var Footer_1 = __importDefault(require("@app/features/dashboard/components/footer/Footer"));
var FooterProvider = /** @class */ (function (_super) {
    __extends(FooterProvider, _super);
    function FooterProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FooterProvider.prototype.render = function () {
        return (react_1.default.createElement(react_redux_1.Provider, { store: this.props.store },
            react_1.default.createElement(Footer_1.default, null)));
    };
    return FooterProvider;
}(react_1.Component));
exports.FooterProvider = FooterProvider;
var ConnectedApp = react_redux_1.connect(null, null)(FooterProvider);
exports.default = root_1.hot(ConnectedApp);
